import { Control, Controller } from "react-hook-form";
import { InputProps, Inputs } from "..";
import { ChangeEvent } from "react";
import * as S from "./InputRadio.style";

interface InputRadioProps extends InputProps {
  control?: Control<any>;
  defaultValue?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const InputRadio = ({
  type = "radio",
  size = "md",
  direction = "column",
  id,
  label,
  placeholder,
  width,
  name,
  disabled,
  control,
  defaultValue,
  onChange,
  options,
  value,
}: InputRadioProps) => {
  if (control) {
    return (
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field, formState }) => (
          <Inputs
            id={id}
            label={label}
            size={size}
            width={width}
            direction={direction}
            errored={!!formState.errors[name]}
            erroredTxt={formState.errors[name]?.message}
          >
            <S.InputRadioBox>
              {options.map((item: any, idx: number) => {
                return (
                  <S.InputRadioLabel key={idx}>
                    <input
                      id={id}
                      type={type}
                      value={item.value}
                      placeholder={placeholder}
                      onChange={field.onChange}
                      disabled={disabled}
                    />
                    <S.InputRadioIcon />
                    {item.display}
                  </S.InputRadioLabel>
                );
              })}
            </S.InputRadioBox>
          </Inputs>
        )}
      />
    );
  }

  return (
    <Inputs
      id={id && id}
      label={label && label}
      size={size}
      width={width}
      direction={direction}
    >
      <S.InputRadioBox>
        {options.map((item: any, idx: number) => {
          return (
            <S.InputRadioLabel key={idx}>
              <input
                name={name}
                id={id && id}
                value={item.value}
                placeholder={placeholder && placeholder}
                type={type}
                disabled={disabled}
                onChange={onChange}
                checked={value === item.value}
              />
              <S.InputRadioIcon />
              {item.display}
            </S.InputRadioLabel>
          );
        })}
      </S.InputRadioBox>
    </Inputs>
  );
};
